<template>
    <el-row :gutter="20" style="padding: 40px;">
        <h1 class="title">公司介绍</h1>

        <div class="subtitle"><i class="el-icon-star-on"></i>关于我们</div>
        <div class="subcontent">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;杭州奕游网络科技有限公司是浙江日报报业集团控股子公司投资,于2019年12月成立，专业的游戏增值服务平台。一对一全程跟踪服务，在线签署电子合同，配合完善的售后服务体系保障买卖双方利益。</div>
      
        <img src="../../../assets/img/zjrb.png" class="zjrb" />
        
        <img src="../../../assets/img/pic1.jpg" class="zjrb" />

    </el-row>

</template>

<script>


export default {
    name: "company",
    data() {
        return {

        };
    },
    components: {

    },
    computed: {

    },
    created() {

    },
    activated() {

    },
    deactivated() {

    },
    methods: {


    }
};
</script>


<style scoped>
.el-row {
    margin-bottom: 20px;
}

.title {
    font-size: 32px;
    width: 100%;
    text-align: center;
    line-height: 50px;
    font-weight: 400;
    color: #ff8800;
}

.subtitle {
    font-size: 20px;
    line-height: 60px;
    font-weight: 400;
   
}

.subcontent {
    font-size: 18px;
    line-height: 30px;
    color: rgb(124, 124, 124);
    padding-left: 20px;
    margin-bottom: 20px;
}

.el-icon-star-on {
    color: #ffa01b;
}

.zjrb{
    margin-top: 30px;
    border-radius: 10px;
    width: 100%;
    height: auto;
}




</style>
